import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import parseInt from 'lodash/parseInt';
import { Button, Col, Form, Input, Row, Spin } from 'antd';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SetPasswordImage from '../../assets/common/login.png';
import { LOGIN } from '../../constants/routes';
import { userMangement } from '../../redux/actions/authActions';

const ResetPasswordScreen = () => {
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState({
    showPasswordEntry: true,
    showSuccess: false,
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const onFinish = (values) => {
    setLoading(true);
    delete values.confirm;
    dispatch(
      userMangement('reset_password', {
        ...values,
        id: parseInt(get(params, 'id')),
        token: query.get('token'),
      })
    )
      .then(() => {
        setLoading(false);
        setCurrentStatus({
          showPasswordEntry: false,
          showSuccess: true,
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const onFinishFailed = () => {};

  useEffect(() => {
    setLoading(true);
    dispatch(
      userMangement('verify.link.reset_password', {
        id: parseInt(get(params, 'id')),
        token: query.get('token'),
      })
    )
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        history.replace('/login');
      });
  }, []);

  return (
    <Spin spinning={loading}>
      <Row>
        <Col span={16} style={{ textAlign: 'center' }}>
          <img src={SetPasswordImage} alt="" />
        </Col>
        <Col span={8}>
          <div className="login-container">
            {get(currentStatus, 'showPasswordEntry') && (
              <>
                <div className="heading">Password Recovery</div>
                <div className="login-form">
                  <Form
                    name="basic"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    requiredMark={false}
                  >
                    <div className="mt-20">
                      <Form.Item
                        label="New Password"
                        name="new_password"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your new password',
                          },
                          {
                            min: 12,
                            message: 'Password must be atleast 12 characters',
                          },
                        ]}
                      >
                        <Input.Password placeholder="Enter your new password" />
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Form.Item
                        label="Re-enter Password"
                        name="confirm"
                        dependencies={['new_password']}
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Please confirm your password',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue('new_password') === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  'The two passwords that you entered do not match'
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="Confirm your new password" />
                      </Form.Item>
                    </div>

                    <div className="mt-60">
                      <Form.Item>
                        <Button type="primary" block htmlType="submit">
                          Continue
                        </Button>
                      </Form.Item>
                    </div>

                    <div className="mt-20">
                      <Button
                        block
                        className="default-btn"
                        onClick={() => {
                          history.push(LOGIN);
                        }}
                      >
                        Back to Login
                      </Button>
                    </div>
                  </Form>
                </div>
              </>
            )}

            {get(currentStatus, 'showSuccess') && (
              <>
                <div className="heading" style={{ justifyContent: 'center' }}>
                  Success!
                </div>

                <div
                  className="mt-40 text-theme-color"
                  style={{ textAlign: 'center' }}
                >
                  Your password has been changed!
                </div>

                <div className="mt-40">
                  <Button
                    block
                    className="default-btn"
                    onClick={() => {
                      history.push(LOGIN);
                    }}
                  >
                    Back to Login
                  </Button>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default ResetPasswordScreen;
